import { Box } from '@mui/material';

import { PageSkeleton } from './PageSkeleton';

/**
 * Shown while a route chunk loads (every route is its own chunk, App.tsx).
 *
 * UX 1.0d (UI-alus §1 "Laadimine"): nothing for the first 200 ms — most
 * chunks arrive sooner, and a flashed spinner reads as a stutter — then the
 * shared PageSkeleton: the page's shape inside one named `aria-busy`
 * container. It used to be a bare spinner, at once, with no busy state.
 * Shared by the admin, client, partner and worker shells and the public
 * routes, so admin gets the same skeleton.
 */
export function RouteFallback() {
  return (
    <Box sx={{ py: 2 }}>
      <PageSkeleton />
    </Box>
  );
}
